import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const BigTruck: FC<SvgIconProps> = ({ viewBox = '0 0 254 180', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M78.138 148.508C82.9405 144.084 83.7475 136.867 79.9404 132.389C76.1333 127.91 69.1538 127.866 64.3513 132.29C59.5487 136.714 58.7417 143.931 62.5488 148.409C66.3559 152.888 73.3354 152.932 78.138 148.508Z"
        fill="black"
      />
      <path
        opacity="0.3"
        d="M87.9324 151.555L166.43 137.159L132.322 120.371L52.8159 135.229L87.9324 151.555Z"
        fill="url(#paint0_linear)"
      />
      <path
        opacity="0.3"
        d="M164.939 137.453L224.367 126.079L189.694 109.291L130.548 121.085L164.939 137.453Z"
        fill="url(#paint1_linear)"
      />
      <path
        opacity="0.3"
        d="M18.8283 165.069L76.8854 153.612L42.1721 136.824L-15.5625 148.743L18.8283 165.069Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M222.996 74.4978L243.276 72.5671L223.278 62.2425C220.819 60.8994 217.795 60.4378 215.094 60.6056L197.233 61.0673L222.996 74.4978Z"
        fill="#FDDE84"
      />
      <path d="M32.4153 85.6619V146.351L9.95847 134.641V74.1201L32.4153 85.6619Z" fill="#C39000" />
      <path
        d="M225.133 120.959C229.936 116.535 230.743 109.318 226.936 104.84C223.129 100.361 216.149 100.317 211.346 104.741C206.544 109.165 205.737 116.382 209.544 120.86C213.351 125.339 220.331 125.383 225.133 120.959Z"
        fill="black"
      />
      <path
        d="M197.354 63.1239L238.8 55.5693L216.626 44.1953C213.602 42.6844 210.135 42.0968 206.829 42.6844L170.583 49.4836L197.354 63.1239Z"
        fill="#FDDE84"
      />
      <path
        d="M243.276 107.738L197.959 115.713V59.8082L231.059 53.9324C237.47 52.7992 243.356 57.9615 243.356 64.7607L243.276 107.738Z"
        fill="#FCCE09"
      />
      <path d="M197.959 59.8083V115.713L175.502 108.955V48.2665L197.959 59.8083Z" fill="#C39000" />
      <path d="M32.4153 85.6619L192.476 55.5693L170.18 44.0275L9.95847 74.1201L32.4153 85.6619Z" fill="#FDDE84" />
      <path
        d="M167.602 131.81C172.405 127.386 173.212 120.169 169.405 115.691C165.598 111.212 158.618 111.168 153.816 115.592C149.013 120.016 148.206 127.233 152.013 131.711C155.82 136.19 162.8 136.234 167.602 131.81Z"
        fill="black"
      />
      <path d="M32.4153 85.6199V146.267L192.476 116.258V55.5693L32.4153 85.6199Z" fill="#FCCE09" />
      <path
        d="M216.666 87.6764V88.264L220.416 87.5085C220.416 86.6271 219.569 85.9556 218.682 85.9976C218.44 85.9976 218.118 85.9976 217.674 86.1655C217.15 86.3334 216.666 87.0468 216.666 87.6764Z"
        fill="#28211E"
      />
      <path d="M32.4153 141.398V151.723L192.476 121.462V111.138L32.4153 141.398Z" fill="#3A3A3A" />
      <path d="M197.959 110.214V120.539L243.356 112.019V101.653L197.959 110.214Z" fill="#3A3A3A" />
      <path d="M32.4153 141.398V151.723L9.95847 140.181V129.856L32.4153 141.398Z" fill="#28211E" />
      <path d="M159.859 136.446L154.658 133.76V127.632H158.125L159.859 136.446Z" fill="black" />
      <path
        d="M151.876 129.605C151.191 122.008 156.714 114.621 163.85 113.152C171.148 111.725 177.397 116.762 178.082 124.358"
        fill="black"
      />
      <path
        d="M172.156 134.142C176.958 129.718 177.765 122.501 173.958 118.022C170.151 113.544 163.172 113.499 158.369 117.923C153.567 122.347 152.76 129.564 156.567 134.043C160.374 138.522 167.353 138.566 172.156 134.142Z"
        fill="#28211E"
      />
      <path
        d="M169.404 130.905C172.272 128.263 172.743 123.939 170.456 121.249C168.169 118.558 163.989 118.519 161.121 121.161C158.253 123.803 157.782 128.126 160.069 130.817C162.357 133.507 166.536 133.547 169.404 130.905Z"
        fill="#3A3A3A"
      />
      <path
        d="M167.213 128.327C168.497 127.144 168.665 125.158 167.588 123.891C166.51 122.624 164.596 122.555 163.312 123.738C162.028 124.921 161.86 126.907 162.938 128.174C164.015 129.442 165.929 129.51 167.213 128.327Z"
        fill="#4C4C4C"
      />
      <path d="M70.3943 153.15L65.1934 150.464V144.336H68.6607L70.3943 153.15Z" fill="black" />
      <path
        d="M62.4115 146.309C61.7261 138.712 67.2496 131.325 74.3858 129.857C81.6832 128.43 87.9324 133.466 88.6178 141.063"
        fill="black"
      />
      <path
        d="M82.6917 150.84C87.4943 146.416 88.3013 139.199 84.4942 134.72C80.6871 130.241 73.7076 130.197 68.9051 134.621C64.1025 139.045 63.2955 146.262 67.1026 150.741C70.9097 155.219 77.8892 155.264 82.6917 150.84Z"
        fill="#28211E"
      />
      <path
        d="M79.9397 147.602C82.8079 144.96 83.2789 140.637 80.9917 137.947C78.7045 135.256 74.5252 135.217 71.657 137.859C68.7888 140.501 68.3179 144.824 70.6051 147.514C72.8923 150.205 77.0715 150.244 79.9397 147.602Z"
        fill="#3A3A3A"
      />
      <path
        d="M77.7488 145.025C79.0328 143.842 79.2005 141.856 78.1233 140.589C77.0461 139.322 75.132 139.253 73.848 140.436C72.5639 141.619 72.3963 143.605 73.4735 144.872C74.5507 146.139 76.4648 146.208 77.7488 145.025Z"
        fill="#4C4C4C"
      />
      <path d="M223.157 92.9227V92.2931L236.543 89.7749V90.3625L223.157 92.9227Z" fill="black" />
      <path d="M223.157 95.315V94.8534L229.487 93.5103V94.0979L223.157 95.315Z" fill="black" />
      <path d="M197.959 110.214V120.539L192.476 117.979V107.402L197.959 110.214Z" fill="#28211E" />
      <path d="M217.351 125.618L212.151 122.931V116.762H215.618L217.351 125.618Z" fill="black" />
      <path
        d="M209.369 118.776C208.683 111.18 214.207 103.793 221.343 102.324C228.64 100.897 234.89 105.934 235.575 113.53"
        fill="black"
      />
      <path
        d="M229.657 123.319C234.459 118.895 235.266 111.678 231.459 107.199C227.652 102.721 220.673 102.676 215.87 107.1C211.068 111.524 210.261 118.741 214.068 123.22C217.875 127.699 224.854 127.743 229.657 123.319Z"
        fill="#28211E"
      />
      <path
        d="M226.905 120.081C229.773 117.439 230.244 113.116 227.957 110.426C225.67 107.735 221.49 107.696 218.622 110.338C215.754 112.98 215.283 117.303 217.57 119.994C219.857 122.684 224.037 122.724 226.905 120.081Z"
        fill="#3A3A3A"
      />
      <path
        d="M224.714 117.504C225.998 116.321 226.166 114.335 225.088 113.068C224.011 111.801 222.097 111.732 220.813 112.915C219.529 114.098 219.361 116.084 220.438 117.351C221.516 118.618 223.43 118.687 224.714 117.504Z"
        fill="#4C4C4C"
      />
      <path d="M38.3419 101.233L47.4134 99.554L46.8086 100.184L38.3419 102.072V101.233Z" fill="#D31116" />
      <path d="M38.3419 99.9737L48.2197 98.0851L47.8166 98.7146L38.3419 100.603V99.9737Z" fill="#D31116" />
      <path d="M38.3419 102.492L46.4054 101.023L46.0023 101.653L38.3419 103.121V102.492Z" fill="#D31116" />
      <path d="M105.35 88.6418L96.3185 90.5304L96.7216 89.691L105.35 88.0122V88.6418Z" fill="#D31116" />
      <path d="M105.35 89.9009L95.5121 91.9994L95.9153 91.16L105.35 89.2713V89.9009Z" fill="#D31116" />
      <path d="M97.7295 88.2221L105.35 86.7531V87.3827L97.3264 89.0615L97.7295 88.2221Z" fill="#D31116" />
      <path
        d="M47.0102 101.443L51.2435 94.7274L56.4848 93.6782C57.0896 93.6782 57.0896 93.6782 56.6864 94.3077L55.6784 95.9865C55.6784 96.1964 55.2753 96.6161 56.0816 96.4062L63.3388 94.9373C61.9277 97.2456 59.9118 98.7146 57.2911 99.3441L47.0102 101.443Z"
        fill="#D31116"
      />
      <path d="M71.7651 93.4683L69.3461 97.0358L63.2984 98.2949L65.5159 94.5176L71.7651 93.4683Z" fill="#D31116" />
      <path d="M80.5946 91.5797L78.1756 95.1472L71.9264 96.4063L74.3454 92.8388L80.5946 91.5797Z" fill="#D31116" />
      <path
        d="M82.6105 91.16L82.0058 92.2092C81.1994 93.4683 82.0058 94.5176 84.4248 94.0979L94.3026 92.2092L96.7216 88.6418C96.7216 88.4319 82.6105 91.16 82.6105 91.16Z"
        fill="#D31116"
      />
      <path
        d="M50.034 91.3698L47.8165 94.7274L59.4683 92.419C60.073 92.419 60.073 92.419 59.6699 93.0486L58.6619 94.7274C58.6619 94.9372 58.2587 95.3569 59.0651 95.1471L63.9032 94.3077L65.3143 91.9993C66.1206 90.5304 65.3143 88.222 62.2905 88.8516L50.034 91.3698Z"
        fill="#D31116"
      />
      <path
        d="M81.1994 90.7402L66.1207 93.888L70.1524 87.3826L76.4016 86.1235L73.9826 89.9008L76.8048 89.2713L79.0222 85.494L85.2311 84.4447L81.1994 90.7402Z"
        fill="#D31116"
      />
      <path d="M93.6978 82.7659L89.4645 89.0614L83.0137 90.5304L87.0454 84.025L93.6978 82.7659Z" fill="#D31116" />
      <path
        d="M236.502 78.6948L215.618 82.0104V63.9633L230.616 61.3191C233.72 60.7735 236.502 63.2498 236.502 66.5234V78.6948Z"
        fill="#3A3A3A"
      />
      <path
        d="M230.656 61.2771L224.81 62.3264L236.543 74.9594V66.4815C236.543 63.2078 233.72 60.7315 230.656 61.2771Z"
        fill="#28211E"
      />
      <path d="M215.658 63.9213V82.0105L229.406 79.7861L218.44 63.4597L215.658 63.9213Z" fill="#4C4C4C" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="98.3665"
        y1="159.197"
        x2="122.473"
        y2="113.748"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2078" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.4522" stopColor="#121211" stopOpacity="0.3368" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="168.75"
        y1="141.373"
        x2="187.317"
        y2="106.368"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="22.0755"
        y1="168.705"
        x2="40.3781"
        y2="134.199"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2692" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset="0.5113" stopColor="#181816" stopOpacity="0.3645" />
        <stop offset="0.8171" stopColor="#080807" stopOpacity="0.8249" />
        <stop offset="0.9333" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="254" height="178.793" fill="white" transform="translate(0 0.546265)" />
      </clipPath>
    </defs>
  </SvgIcon>
)
